module.exports = __webpack_public_path__ + "static/5-aadeffffc5d7133839b9ef247f8c7b62.jpeg";